import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslocoPipe } from '@jsverse/transloco';
import { __, MapPopupComponent, MessengerService, SafeHtmlPipe } from '@web/birdz-angular';
import { MapPds } from 'app/interfaces/map-pds.interface';
import { Api } from 'app/services/api.service';
import { AppsService } from 'app/services/apps.service';
import { FilterService } from 'app/services/filter.service';
import Feature from 'ol/Feature';
import { finalize, tap } from 'rxjs';

@Component({
  selector: 'app-card-map-popup',
  imports: [MapPopupComponent, TranslocoPipe, SafeHtmlPipe],
  templateUrl: './card-map-popup.component.html',
  styleUrl: './card-map-popup.component.scss',
})
export class CardMapPopupComponent implements OnInit {
  @Input({ required: true }) data!: { feature: Feature; close: () => void; context: unknown };

  private api = inject(Api);
  private filterService = inject(FilterService);
  private appsService = inject(AppsService);
  private messenger = inject(MessengerService);
  private destroyRef = inject(DestroyRef);

  isLoading = 0;
  pds: MapPds | null = null;
  appLinkHTML = '';
  equipmentLabel = '';

  get techno() {
    return this.filterService.getTechno();
  }

  get showState() {
    return this.techno === 'watermetering';
  }

  ngOnInit() {
    const id = this.data.feature.get('id') as string;
    this.equipmentLabel = __(this.techno === 'sewerin' ? 'POPUP_SEWERIN' : 'POPUP_EQUIPMENT');

    this.isLoading++;
    this.api
      .fetchPds(id, this.techno)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        this.messenger.showFriendlyErrorMessage(),
        tap((pds: MapPds) => {
          this.pds = pds;
          const contract = this.filterService.getContract();
          this.appLinkHTML =
            contract !== null && this.techno === 'sewerin'
              ? pds.noiseLevel !== null
                ? this.appsService.getLeaksLinkHTML(contract, pds.id, pds.noiseLevel)
                : ''
              : this.appsService.getPdsLinkHTML(pds.id);
        }),
        finalize(() => this.isLoading--)
      )
      .subscribe();
  }
}
